import React, { useState } from "react";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ViewListIcon from '@material-ui/icons/ViewList';
import { LibraryBooks, Home, Apps, ContactPhone, Face } from "@material-ui/icons";
import Testimonails from '@material-ui/icons/VerifiedUser';
import { makeStyles } from "@material-ui/core/styles";
import Sidebar from "./Sidebar";

const useStyles = makeStyles(() => ({
    appbar: {
        background: "black",
        margin: 0,
        width: '100%',
        height: "8vh",
        padding: '0.3rem',
        display: 'flex',
        justifyContent: "space-between",
    },
    arrow: {
        color: "orange",
    },
    title: {
        color: "orange",
    },

}));

const Navbar = () => {

    const [navItems] = useState([
        { listIcon: <Home />, listText: "Home", listPath: "/" },
        { listIcon: <Face />, listText: "About Me", listPath: "/about" },
        { listIcon: <Apps />, listText: "Projects", listPath: "/projects" },
        { listIcon: <Testimonails />, listText: "Testimonials", listPath: "/testimonials" },
        { listIcon: <ContactPhone />, listText: "Contact", listPath: "/contact" },
        { listIcon: <LibraryBooks />, listText: "Skills/Resume", listPath: "/resume" },
    ]);
    const [open, setOpen] = useState(false);

    const classes = useStyles();

    return (
        <React.Fragment>
            <Box component="nav">
                <AppBar position="static" className={classes.appbar}>
                    <Toolbar>
                        <IconButton aria-label="Menu Items" onClick={() => setOpen(true)}>
                            <ViewListIcon className={classes.arrow} />
                        </IconButton>
                        <Typography variant="h5" className={classes.title}>
                            My Portfolio
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
            <Drawer open={open} anchor="left" onClose={() => setOpen(false)}>
                <Sidebar
                    navItems={navItems}
                />
            </Drawer>
        </React.Fragment>
    );
};

export default Navbar

